import { render, staticRenderFns } from "./ListKecepatanTempuhPage.vue?vue&type=template&id=70cd22ae&scoped=true"
import script from "./ListKecepatanTempuhPage.vue?vue&type=script&lang=js"
export * from "./ListKecepatanTempuhPage.vue?vue&type=script&lang=js"
import style0 from "./ListKecepatanTempuhPage.vue?vue&type=style&index=0&id=70cd22ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd22ae",
  null
  
)

export default component.exports